exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-quiz-create .ant-radio-group{width:100%}.form-quiz-create .create-dialog-form__group--indent-bottom select{height:35px;padding:0 15px;line-height:35px}.form-quiz-create .create-dialog-form__group{width:100%;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/QbmQuiz/components/FormContent/style.scss
// module id = 4919
// module chunks = 0